import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as COMPANIES_SELECTORS from '../../../store/selectors/companies';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import { emptyFunc } from '../../../helpers/function/emptyFunc';

import styles from './openNewWindowConfirmDialog.module.scss';

const OpenNewWindowConfirmDialog = (props) => {
    const {
        isVisible,
        onClose,
        onConfirm,
    } = props;

    const { t } = useTranslation(LOCALE_NAMESPACE.COMMON);

    const { tintColor } = useSelector(COMPANIES_SELECTORS.companiesSelector);

    const confirmButtonStyle = useMemo(() => ({
        background: tintColor,
    }), [tintColor]);

    return (
        <Modal
            show={isVisible}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
            centered
        >
            <Modal.Header closeButton />
            
            <Modal.Body>
                <div 
                    className={styles.contentContainer}
                >
                    {t('openNewWindowConfirmDialog.text')}
                </div>
            </Modal.Body>

            <Modal.Footer className={styles.dialogFooter}>
                <Button
                    onClick={onConfirm}
                    style={confirmButtonStyle}
                    className={styles.confirmButton}
                >
                    {t('openNewWindowConfirmDialog.ok')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

OpenNewWindowConfirmDialog.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
};

OpenNewWindowConfirmDialog.defaultProps = {
    isVisible: false,
    onClose: emptyFunc,
    onConfirm: emptyFunc,
};

export default OpenNewWindowConfirmDialog;
